export function getMetaValue (name: string): object {
  const element = findElement(document.head, `meta[name="${name}"]`)
  if (element != null) {
    return element.getAttribute('content')
  }
}

export function findElement (root: object, selector: String): object {
  if (typeof (root) === 'string') {
    selector = root
    root = document
  }
  return root.querySelector(selector)
}

export function removeElement (el: Element): void {
  if (el != null) {
    el.parentNode.removeChild(el)
  }
}

export function insertAfter (el: Element, referenceNode: Element): Element {
  return referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling)
}
